import { Row, Col, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';

import { LocationDotIcon } from 'assets/icons/location-dot';

import helpYateemLightLogo from 'assets/img/we-raise-images/front-end/hy-logo-white.png';
import footerPaymentImage from 'assets/img/we-raise-images/front-end/payment-icons-1.png';
import footerLeftImage from 'assets/img/we-raise-images/frontEndFooterLeft.png';
import footerRightImage from 'assets/img/we-raise-images/frontEndFooterRight.png';

function DonationFooter() {
  return (
    <div className="bg-wr-donation-primary">
      <div className="container pt-5 pb-4">
        <Row className="align-items-start">
          <Col sm={6} md={4} className="d-flex flex-column">
            <Image
              src={helpYateemLightLogo}
              alt="Help Yateem"
              className="mb-1"
              style={{ maxWidth: '220px', marginTop: '-25px' }}
            />
          </Col>
          <Col sm={6} md={4} className="d-flex flex-column gap-3" style={{ fontSize: '1.15rem' }}>
            <h3 className="mb-3 text-white wr-donation-body3">
              Contact Details
            </h3>
            <p className="m-0 text-white">
              <FontAwesomeIcon className="me-2" icon="envelope" />
              <a
                href="mailto:info@helpyateem.org"
                className="text-white wr-donation-body4"
              >
                info@helpyateem.org
              </a>
            </p>
            <p className="m-0 text-white">
              <FontAwesomeIcon className="me-2" icon="phone" />
              <a
                href="tel:+44 (0)207 550 6899"
                className="text-white wr-donation-body4"
              >
                +44 (0)207 550 6899
              </a>
            </p>
            <p className="m-0 text-white d-flex">
              <span className="me-2">
                <LocationDotIcon />
              </span>
              <span>
                Hyat Hub, Suite 13, Durning Hall,<br />Earlham Grove, London, E7 9AB
              </span>
            </p>
          </Col>
          <Col sm={12} md={4} className="d-flex flex-column align-items-center align-items-md-end pe-0 mt-4 mt-md-0" style={{ marginRight: '-20px' }}>
            <Image src={footerPaymentImage} alt="Payment Methods" className="w-100" style={{ maxWidth: '450px' }} />
            <div className="d-flex align-items-center justify-content-between w-100 mt-3" style={{ maxWidth: '450px' }}>
              <p className="m-0 text-white wr-donation-body4 ms-2">
                Charity Number: 1158571
              </p>
              <Image src={footerLeftImage} alt="Fundraising Regulator" height="40px" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

function FooterImages() {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
      <Image src={footerLeftImage} height="61px" className="mb-4 mb-md-0" />
      {/* <Image
        src={footerRightImage}
        height="84px"
        style={{ maxWidth: '362px' }}
        className="w-100 h-100"
      /> */}
    </div>
  );
}

function PrivacyPolicy() {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <div className="text-center wr-donation-text-grey-700">
      Privacy Policy | Other ways to donate (Telephone, post & bank transfer)
      <br />© Copyrights {currentYear} Help Yateem. All rights
      reserved. Registered Charity No. 1158571
    </div>
  );
}

export { DonationFooter, FooterImages, PrivacyPolicy };
